import React from "react";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import { formatDate } from "../../../JsHelpers/DateFormat";
import trans from "../../../utils";
import { Tag } from "antd";

export default function CustomerInf({ values = {} }) {
	const getValue = (value, defaultValue = "-----") =>
		value ? value : defaultValue;

	const {
		name = "",
		email = "",
		phoneNumber = "",
		website = "",
		fax = "",
		status = "",
		createdBy = "",
		updatedBy = "",
		createdAt = "",
		updatedAt = "",
		taxId = "",
	} = values;
	const formattedCreatedAt = createdAt
		? formatDate(createdAt).formattedDate
		: "-----";
	const formattedUpdatedAt = updatedAt
		? formatDate(updatedAt).formattedDate
		: "-----";
	const truncateItem = (text) => {
		const maxLength = 35;
		return text?.length > maxLength
			? text.substring(0, maxLength) + "..."
			: text;
	};
	return (
		<div>
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("Customer Details")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem title={trans("Name")} item={getValue(name)} />
						<PopupBodyItem
							title={trans("phone number")}
							item={getValue(phoneNumber)}
						/>
						<PopupBodyItem title={trans("Fax")} item={getValue(fax)} />
						<PopupBodyItem
							title={trans("Status")}
							item={getValue(
								status ? (
									<Tag color="green">{trans("Active")}</Tag>
								) : (
									<Tag color="red">{trans("Inactive")}</Tag>
								)
							)}
						/>{" "}
						<PopupBodyItem
							title={trans("Created At")}
							item={getValue(formattedCreatedAt)}
						/>{" "}
						<PopupBodyItem
							title={trans("updated by")}
							item={getValue(updatedBy?.name || "- - - -")}
						/>
						{values?.contactPerson !== null && (
							<PopupBodyItem
								title={trans("Contact Person Name")}
								item={getValue(values?.contactPerson?.name)}
							/>
						)}
					</div>
				</div>
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem title={trans("Email")} item={getValue(email)} />
						<div className="flex-between border-bottom popupbody-item">
							<div className={`fs-16 fw-400 neutral-400 text-capitalize`}>
								{trans("Website")}
							</div>
							<a
								href={truncateItem(getValue(website))}
								target="blank"
								className={`fs-14 fw-500`}
							>
								{getValue(website)}
							</a>
						</div>
						<PopupBodyItem title={trans("Tax Id")} item={getValue(taxId)} />

						<PopupBodyItem
							title={trans("Created By")}
							item={getValue(createdBy?.name || "- - - -")}
						/>

						<PopupBodyItem
							title={trans("updated at")}
							item={getValue(formattedUpdatedAt)}
						/>
						{values?.contactPerson !== null && (
							<>
								<PopupBodyItem
									title={trans("Contact Person Phone")}
									item={getValue(values?.contactPerson?.phone)}
								/>
								<PopupBodyItem
									title={trans("Contact Person Email")}
									item={getValue(values?.contactPerson?.email)}
								/>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
